module.exports = __webpack_public_path__ + "static/media/on-demand-practice.7d36db81.svg";